import NaePagingGroup from './NaePagingGroup'
import NaePagingPrev from './NaePagingPrev'
import NaePagingNext from './NaePagingNext'
import NaePagingBtn from './NaePagingBtn'

export default {
  Group: NaePagingGroup,
  Prev: NaePagingPrev,
  Next: NaePagingNext,
  Btn: NaePagingBtn
}
